import { render, staticRenderFns } from "./AuthButtons.vue?vue&type=template&id=67393502&scoped=true&"
import script from "./AuthButtons.vue?vue&type=script&lang=js&"
export * from "./AuthButtons.vue?vue&type=script&lang=js&"
import style0 from "./AuthButtons.vue?vue&type=style&index=0&id=67393502&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67393502",
  null
  
)

export default component.exports